/* ============================================================
   Notre Chanson — recap.js
   Populates "Vérifiez les détails" from the saved brief,
   validates the email, and moves to the cart (panier.html).
   ============================================================ */
(function () {
  'use strict';

  var A = NM.answers;

  // Guard: no brief yet → send the user back to the composer.
  if (!A.relation) { window.location.replace(NM.route('composer')); return; }

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function set(field, value) {
    document.querySelectorAll('[data-field="' + field + '"]').forEach(function (el) { el.textContent = value; });
  }

  var name = NM.displayName();
  document.querySelectorAll('[data-name]').forEach(function (el) { el.textContent = name; });

  set('pour', A.prenom ? A.prenom : NM.relationLabel());
  set('livraison', 'avant le ' + NM.deliveryLabel());
  set('style', NM.genreLabel());
  set('voix', NM.voiceLabel());
  set('souvenirs', A.souvenirs || '—');

  // Qualities as tags
  var qualsEl = document.querySelector('[data-field="qualites"]');
  var quals = (A.qualities || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  if (quals.length) {
    qualsEl.innerHTML = quals.map(function (q) { return '<span class="nm-qtag">' + esc(q) + '</span>'; }).join('');
  } else { qualsEl.textContent = '—'; }

  // Personal message: hide the row entirely if empty (it's optional)
  var msgRow = document.querySelector('[data-msg-row]');
  if (A.message && A.message.trim()) { set('message', A.message); }
  else if (msgRow) { msgRow.hidden = true; }

  // ---- Email ----
  var input = document.getElementById('email');
  var errBox = document.getElementById('email-error');
  var form = document.getElementById('email-form');
  if (NM.state.email) input.value = NM.state.email;

  function valid(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  function submit() {
    var v = input.value.trim();
    if (!valid(v)) { errBox.hidden = false; input.focus(); return; }
    NM.setEmail(v);
    if (window.nmPixel) nmPixel('Lead', { content_name: 'Chanson personnalisée', value: 39, currency: 'EUR' });
    window.location.href = NM.route('panier');
  }

  form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
  input.addEventListener('input', function () { errBox.hidden = true; });
  document.querySelectorAll('[data-submit-email]').forEach(function (b) {
    b.addEventListener('click', submit);
  });

  // Sample players — real audio playback, one track at a time.
  var samples = [].slice.call(document.querySelectorAll('.nm-sample'));
  samples.forEach(function (el) {
    var audio = el.querySelector('[data-sample-audio]');
    var btn = el.querySelector('[data-sample-play]');
    if (!audio || !btn) return;
    audio.addEventListener('play', function () {
      samples.forEach(function (o) {
        var a = o.querySelector('[data-sample-audio]');
        if (a && a !== audio) a.pause();
      });
      el.classList.add('is-playing');
    });
    audio.addEventListener('pause', function () { el.classList.remove('is-playing'); });
    audio.addEventListener('ended', function () { el.classList.remove('is-playing'); audio.currentTime = 0; });
    btn.addEventListener('click', function () {
      if (audio.paused) { var p = audio.play(); if (p && p.catch) p.catch(function () {}); }
      else { audio.pause(); }
    });
  });
})();
